import { type FC } from 'react'

import { FlowActionDropdown } from 'widgets/Flow/ui/FlowActionDropdown/FlowActionDropdown'
import styles from './styles.module.scss'

type IActionsProps = {
  setOpen: (value: boolean) => void
  Content: FC<{ setOpen: (value: boolean) => void }>
}

export const Actions = ({ setOpen, Content }: IActionsProps) => {
  return (
    <FlowActionDropdown
      setOpen={setOpen}
      className={styles.dropdown}
      Content={() => <Content setOpen={setOpen} />}
    />
  )
}
